import { render, staticRenderFns } from "./direct-send.vue?vue&type=template&id=65a5d628&"
import script from "./direct-send.vue?vue&type=script&lang=js&"
export * from "./direct-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a5d628')) {
      api.createRecord('65a5d628', component.options)
    } else {
      api.reload('65a5d628', component.options)
    }
    module.hot.accept("./direct-send.vue?vue&type=template&id=65a5d628&", function () {
      api.rerender('65a5d628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/direct-send.vue"
export default component.exports